import { TimeInput } from './TimeInput';
import { DayState } from '../_types';
import { useInputs } from '../useInputs';

export const DayInput = () => {
  const { state, setState, isView } = useInputs<DayState>();
  return (
    <TimeInput
      time={state.at}
      onTimeChange={(newTime) =>
        setState((state) => ({ ...state, at: newTime }))
      }
      InputProps={{ readOnly: isView }}
      label="At:"
    />
  );
};
